;(function() {
  'use strict'

  angular.module('core.bootLoader', [])
})()
